import LoginLayoutWrapper from "../commons/layout/LogginLayoutWrapper";
import SeleccionUsuarioFormContainer from "./SeleccionUsuarioFormContainer";

const Empleador = () => {

  return (
    <LoginLayoutWrapper>
      <SeleccionUsuarioFormContainer />
    </LoginLayoutWrapper>
  )
}

export default Empleador;